var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowLeft56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M37.854 7.146a.5.5 0 0 1 0 .708L18.207 27.5l19.647 19.646a.5.5 0 0 1-.708.708l-20-20a.5.5 0 0 1 0-.708l20-20a.5.5 0 0 1 .708 0Z",
  clipRule: "evenodd"
})));
export { SvgBigArrowLeft56 as ReactComponent };
export default __webpack_public_path__ + "c9f022d26afd636a4179267d0f0853a3.svg";